import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const PEDOLOGY_COMPARE_BASE_V1 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.PEDOLOGY,
  VERSIONS.V1,
  'compare',
  false // No tenant ID in the base URL
);
const PEDOLOGY_EVALUATE_BASE_V1 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.PEDOLOGY,
  VERSIONS.V1,
  'evaluate',
  false // No tenant ID in the base URL
);
const PEDOLOGY_FARMLAND_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.PEDOLOGY,
  VERSIONS.V2,
  'farmland',
  false // No tenant ID in the base URL
);
const PEDOLOGY_MONITOR_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.PEDOLOGY,
  VERSIONS.V2,
  'monitor',
  false // No tenant ID in the base URL
);

export const getSoilComparison = data =>
  client.post(`${PEDOLOGY_COMPARE_BASE_V1}/`, data);

export const getSoilParameter = cluster =>
  client.get(`${PEDOLOGY_EVALUATE_BASE_V1}/${cluster}/`);

export const getSoilMonitoring = cluster =>
  client.get(`${PEDOLOGY_MONITOR_BASE_V2}/${cluster}/`);

export const getPedologyData = ({ tenant_id, parent_id, project_ids }) =>
  client.post(`${PEDOLOGY_FARMLAND_BASE_V2}/`, {
    tenant_id: tenant_id,
    parent_id: parent_id,
    project_ids: project_ids
  });
